import { styled, SxProps, Theme } from "@mui/material";
import React from "react";

type Props = {
  value?: string;
  backgroundColor?: string;
  textColor?: string;
  classes?: any;
  sxText?: SxProps<Theme>;
  sxBadge?: SxProps<Theme>;
};

const StyledBadge = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minWidth: "51px",
  padding: "6px 16px",
  height: "40px",
  borderRadius: "20px"
}));

const StyledText = styled("span")(() => ({
  fontFamily: "Inter",
  fontSize: "10px",
  fontWeight: 600,
  lineHeight: "20px"
}));

const BadgeTaskType = (props: Props) => {
  const { value, sxBadge, sxText } = props;

  const renderBadge = (
    backgroundColor: string,
    textColor: string,
    value?: string
  ) => {
    if (value)
      return (
        <StyledBadge sx={{ backgroundColor, ...sxBadge }}>
          <StyledText sx={{ color: textColor, ...sxText }}>{value}</StyledText>
        </StyledBadge>
      );
    return <> </>;
  };

  switch (value?.toLowerCase()) {
    case "pre-pack":
      return renderBadge("#d1dade", "#677080", value);
    case "local":
      return renderBadge("#f1a30f", "#f3f8f2", value);
    case "receival":
      return renderBadge("#e575d1", "#ebe9e9", value);
    case "delivery":
      return renderBadge("#9585bf", "#4a0d67", value);
    case "dispatch":
      return renderBadge("#f7be04", "#d0e1d4", value);
    case "transhipment":
      return renderBadge("#72220f", "#fbfbff", value);
    case "dropoff":
      return renderBadge("#9bd8d6", "#0b4f6c", value);
    case "pickup":
      return renderBadge("#121213", "#fbfbff", value);
    case "inventory":
      return renderBadge("#e64e1c", "#f5e0b7", value);
    case "uplift":
      return renderBadge("#65c8c8", "#fff", value);
    default:
      return renderBadge("#d1d4e0", "#464D69", value);
  }
};

export default BadgeTaskType;
